import GenericOptionsWidget from '../components/GenericOptionsWidget';

export default function Options() {
  return (
    <div>
      <GenericOptionsWidget />
    </div>
  );
}
